import { memo, useRef } from 'react';

import { type MentionsData } from '~/components/Discussions/DiscussionForm';
import { UserMentionTooltip } from '~/components/Discussions/UserMention/components/UserMentionTooltip';
import { useHover } from '~/hooks/useHover';

export type UserMentionProps = {
  userName: string;
  user?: MentionsData;
};

export const UserMention = memo(({ userName, user }: UserMentionProps) => {
  const textRef = useRef<HTMLElement>(null);
  const { handleHover, isHovering, handleUnhover } = useHover();

  return (
    <span data-testid="USER_MENTION" data-user-name={userName} onMouseEnter={handleHover} onMouseLeave={handleUnhover}>
      {isHovering && user && <UserMentionTooltip containerRef={textRef} user={user} />}
      <span className="cursor-pointer font-medium text-14 text-grey-11" ref={textRef}>
        {userName}
      </span>
    </span>
  );
});

UserMention.displayName = 'UserMention';
